@if (playerProfile) {
  @if (playerProfile.registrationPin) {
    <div class="flex align-items-center gap-3">
      <div class="flex align-items-center gap-1 cursor-pointer accent-hover"
           [pTooltip]="'REGISTRATION_CODE' | translate" [showDelay]="400"
           [cdkCopyToClipboard]="playerProfile.registrationPin"
           (click)="restErrorHelper.showInfoMessageService('COPIED_TO_CLIPBOARD', 1500)">
        {{ playerProfile.registrationPin | registrationCodePipe: playerProfile.registrationPinValidTo }}
        <i class="pi pi-copy"></i>
      </div>
      <div>
        <p-button icon="pi pi-trash" styleClass="p-button-text"
                  [disabled]="isDeleting" [loading]="isDeleting"
                  (onClick)="deleteRegistrationCode()"/>
      </div>
    </div>
  } @else {
    <div class="flex align-items-center gap-2">
      <div>{{'NO_REGISTRATION_CODE' | translate}}</div>
      <p-button icon="pi pi-plus" styleClass="p-button-text" [label]="'CREATE' | translate"
                [disabled]="isCreating" [loading]="isCreating"
                (onClick)="createRegistrationCode()"/>
    </div>
  }
}
